import { useTar } from '@/modules'
import { Button } from '@duck/ui'
import { useAuth } from '@/hooks/useAuth'
import { LockClosedIcon } from '@heroicons/react/24/outline'

export const LoginRequiredEmptyState = () => {
  const { t } = useTar()
  const { openLoginDialog } = useAuth()
  const handleLoginClick = () => {
    openLoginDialog()
  }
  return (
    <div className="text-center py-12 max-w-md mx-auto">
      <LockClosedIcon className="w-16 h-16 text-muted mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {t('challenges.availableForRegisteredUsersOnly')}
      </h3>
      <p className="text-muted-foreground mb-6">
        {t('challenges.loginRequiredDescription')}
      </p>
      <Button
        variant="default"
        className="w-full"
        onClick={handleLoginClick}
      >
        {t('common.login')}
      </Button>
    </div>
  )
}
